import React from 'react';
import styles from './item.module.css';

class itemText extends React.Component{
   constructor(props){
     super(props);
   }
    render(){
      if(this.props.data){
        return (
          <pre className={ styles.contentText} dangerouslySetInnerHTML={{__html: this.props.data.content}}></pre>
          )
      }else{
        return (
          <div></div>
        )
      }
    }
  }
export default itemText